import {Theme} from '@mui/material/styles';
import {FirebaseApp} from 'firebase/app';
import {ThemeMode} from '../../enums/theme-mode';
import {ThemeOption} from '../../enums/theme-option';
import {AppConfig} from '../../interfaces/app-config';
import {ThemeSettings} from '../../interfaces/theme-settings';

export interface AppContextState {
  firebaseApp: FirebaseApp;
  configuration: AppConfig;
  currentTheme: Theme;
  currentThemeMode: ThemeMode;
  currentThemeSettings: ThemeSettings;
  runningFromSocialApp: boolean;
}

export enum AppContextActionType {
  CHANGE_THEME_MODE = 'CHANGE_THEME_MODE',
}

export type AppContextAction = {
  type: AppContextActionType.CHANGE_THEME_MODE;
  theme: Theme;
  themeMode: ThemeMode;
};

export interface AppContextType {
  state: AppContextState;

  // Methods
  init: () => void;
  changeThemeMode: (option: ThemeOption) => void;
}
